import formInputsTypes from '../simulatorConstant';

const forfaitsData = [
	{
		id: 20,
		label: 'Forfait Déblocage du rideau métallique',
		value: 'Forfait Déblocage du rideau métallique',
		description:
			'*Forfait Déblocage du rideau métallique :\n' +
			'- Diagnostic et identification de la cause du blocage\n' +
			'- Manipulation et déblocage manuel du rideau métallique\n' +
			'- Vérification du bon fonctionnement après intervention\n' +
			'- Nettoyage et remise en ordre de la zone de travail\n',
		lst_price: 330,
		isInline: true,
	},

	{
		id: 4,
		label: "Forfait Remplacement d'une serrure a l'identique d'un rideau métallique",
		value: "Remplacement d'une serrure a l'identique d'un rideau métallique",
		description:
			"*Forfait Remplacement d'une serrure a l'identique d'un rideau métallique\n" +
			'- Sécurisation du rideau métallique :\n' +
			'- Dépose de l’ancienne serrure\n' +
			'- Pose de la serrure neuve à l’identique\n' +
			'- Réglages et tests de bon fonctionnement\n',
		lst_price: 180,
		isInline: true,
	},

	{
		id: 4,
		label: 'Forfait Remplacement de télécommande',
		value: 'Remplacement de télécommande',
		description:
			'* Forfait Remplacement de télécommande : \n' +
			'Fourniture :\n' +
			'- Remplacement de la télécommande adapté a la motorisation existante \n' +
			'- Paramétrage des canaux et fonctions selon l’installation\n\n' +
			'Main d’œuvre :\n' +
			'- Diagnostic du système de motorisation et de la compatibilité de la télécommande\n' +
			'- Mise en mode apprentissage du moteur ou du récepteur\n' +
			'- Programmation et synchronisation de la télécommande\n' +
			'- Test des fonctions montée / descente / arrêt\n' +
			'- Vérification du bon fonctionnement et de la portée de la télécommande\n',

		lst_price: 220,
		isInline: true,
	},

	{
		id: 9,
		label: 'Forfait remplacement des agrafes de rideau métallique',
		value: 'Forfait remplacement des agrafes de rideau métallique',
		description:
			'*Forfait remplacement des agrafes de rideau métallique :\n' +
			'- Dépose des agrafes défectueuses du rideau métallique\n' +
			'- Fourniture et pose de nouvelles agrafes compatibles\n' +
			'- Réglage et fixation du rideau sur l’axe\n' +
			'- Vérification du bon fonctionnement après intervention\n',
		lst_price: 180,
		isInline: true,
	},
	{
		id: 17,
		label: "Forfait fourniture et pose d'un sabot de rideau métallique",
		value: "Forfait fourniture et pose d'un sabot de rideau métallique",
		description:
			"*Forfait fourniture et pose d'un sabot de rideau métallique :\n" +
			'- Fourniture d’un sabot compatible avec le rideau métallique existant\n' +
			'- Dépose de l’ancien sabot si nécessaire\n' +
			'- Pose et fixation du nouveau sabot\n' +
			'- Réglage et test du bon fonctionnement du rideau métallique\n',
		lst_price: 220,
		isInline: true,
	},
];

const forfaitsRideau = {
	id: 'ForfaitsSM',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Forfaits',
	name: 'ForfaitsSM',
	className: 'col-12',
	classGroup: 'simulator-check',
	options: forfaitsData,
};

export default forfaitsRideau;
